import { get } from "lodash-es";
import { useMapContext } from "../context/MapContext";
import { loadMap } from "../repositorie/MapRepositories";
import { useCreateMap } from "./useCreateMap";

type Props = {
	setError: (err: string) => void;
};

export const useLoadMapProps = ({ setError }: Props) => {
	const {
		state: { currAssetId },
		actions: {
			setAssetChildrensFromApi,
			setAssetNameFromApi,
			setRMWorkOrdersFromApi,
			setPMWorkOrdersFromApi,
		},
	} = useMapContext();

	const { loadAssetComponent, createGenericMap } = useCreateMap();

	return async () => {
		const res = await loadMap(currAssetId);
		const assetName = get(res, "data.tables[0].rows[0].AssetName", "");
		if (res.ok) {
			const rmWorkOrders = get(res, "data.tables[0].rows[0].RMWorkOrders", "");
			const pmWorkOrders = get(res, "data.tables[0].rows[0].PMWorkOrders", "");

			// Store asset name and work orders for CURRENT badge (Iteration 3)
			setAssetNameFromApi(assetName);
			setRMWorkOrdersFromApi(rmWorkOrders);
			setPMWorkOrdersFromApi(pmWorkOrders);
			const pmWorkOrdersClosed = get(
				res,
				"data.tables[0].rows[0].PMWorkOrdersClosed",
				"",
			);
			const rmWorkOrdersClosed = get(
				res,
				"data.tables[0].rows[0].RMWorkOrdersClosed",
				"",
			);

			const svgMap = get(res, "data.tables[0].rows[0].SvgMap", null);
			const isActive = get(res, "data.tables[0].rows[0].isActive", null);

			const assetsProps = get(res, "data.tables[1].rows", []);

			setAssetChildrensFromApi(assetsProps);

			const assetNameString = assetName
				.toString()
				.toLowerCase()
				.replace(/\(|\)/g, "")
				.replace(/#/g, "")
				.replace(/\//g, "-")
				.replace(/ /g, "-");
			if (svgMap) {
				loadAssetComponent(
					assetName,
					assetsProps,
					assetNameString,
					svgMap,
					rmWorkOrders,
					pmWorkOrders,
					pmWorkOrdersClosed,
					rmWorkOrdersClosed,
					isActive,
				);
			} else {
				createGenericMap(
					assetName,
					assetsProps,
					assetNameString,
					rmWorkOrders,
					pmWorkOrders,
					pmWorkOrdersClosed,
					rmWorkOrdersClosed,
					isActive,
				);
			}
		} else {
			setError(res.message);
		}
	};
};
